import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../modules/employeesActions'
import * as api from '../api/employee'

function* fetchEmployees(action) {
  try {
    const payload = yield call(api.getEmployeesList, action)
    yield put({ type: constants.EMPLOYEES_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EMPLOYEES_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* employeesRefresh() {
  yield takeLatest(constants.EMPLOYEES_REFRESH.ACTION, fetchEmployees)
}

function* createEmployee(action) {
  try {
    const payload = {
      content: action.content,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }
    yield call(api.createEmployee, payload)
    yield put({ type: constants.CREATE_EMPLOYEE.SUCCESS, payload })
    yield call(fetchEmployees)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_EMPLOYEE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateEmployee() {
  yield takeLatest(constants.CREATE_EMPLOYEE.ACTION, createEmployee)
}

function* editEmployee(action) {
  try {
    const payload = {
      content: action.content,
      employeeId: action.employeeId
    }
    yield call(api.editEmployee, payload)
    yield put({ type: constants.EDIT_EMPLOYEE.SUCCESS, payload })
    yield call(fetchEmployees)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_EMPLOYEE.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditEmployee() {
  yield takeLatest(constants.EDIT_EMPLOYEE.ACTION, editEmployee)
}

function* deleteEmployee(action) {
  try {
    const payload = {
      employeeId: action.employeeId
    }
    yield call(api.deleteEmployee, payload)
    yield put({ type: constants.DELETE_EMPLOYEE.SUCCESS, payload })
    yield call(fetchEmployees)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_EMPLOYEE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteEmployee() {
  yield takeLatest(constants.DELETE_EMPLOYEE.ACTION, deleteEmployee)
}

function* editEmployeeStatus(action) {
  try {
    const payload = {
      content: action.content,
      employeeId: action.employeeId
    }
    yield call(api.editEmployeeStatus, payload)
    yield put({ type: constants.EDIT_EMPLOYEE_STATUS.SUCCESS, payload })
    yield call(fetchEmployees)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_EMPLOYEE_STATUS.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditEmployeeStatus() {
  yield takeLatest(constants.EDIT_EMPLOYEE_STATUS.ACTION, editEmployeeStatus)
}

// ATTACHMENT SAGAS
function* uploadAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      employeeId: action.employeeId
    }

    yield call(api.uploadAttachments, payload)
    yield put({ type: constants.UPLOAD_EMPLOYEE_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { employeeId: action.employeeId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_EMPLOYEE_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadAttachments() {
  yield takeLatest(constants.UPLOAD_EMPLOYEE_ATTACHMENT.ACTION, uploadAttachments)
}

function* getAttachments(action) {
  try {
    const payload = yield call(api.getAttachments, action.employeeId)
    yield put({ type: constants.GET_EMPLOYEE_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_EMPLOYEE_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAttachments() {
  yield takeLatest(constants.GET_EMPLOYEE_ATTACHMENTS.ACTION, getAttachments)
}

function* updateAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: 1,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_EMPLOYEE_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getAttachments, { employeeId: action.employeeId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_EMPLOYEE_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_EMPLOYEE_ATTACHMENT_DESCRIPTION.ACTION,
    updateAttachmentDescription
  )
}

function* deleteAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      employeeId: action.employeeId
    }

    yield call(api.deleteAttachment, payload)
    yield put({ type: constants.DELETE_EMPLOYEE_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { employeeId: action.employeeId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_EMPLOYEE_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteAttachments() {
  yield takeLatest(constants.DELETE_EMPLOYEE_ATTACHMENT.ACTION, deleteAttachment)
}

// notes
function* fetchEmployeeNote(action) {
  try {
    const payload = yield call(api.fetchEmployeeNote, { employeeId: action.employeeId })
    yield put({ type: constants.GET_EMPLOYEE_NOTE.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_EMPLOYEE_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchEmployeeNote() {
  yield takeLatest(constants.GET_EMPLOYEE_NOTE.ACTION, fetchEmployeeNote)
}

function* createEmployeeNote(action) {
  try {
    const payload = {
      content: action.content,
      employeeId: action.employeeId
    }
    yield call(api.createEmployeeNote, payload)
    yield put({ type: constants.CREATE_EMPLOYEE_NOTE.SUCCESS, payload })
    yield call(fetchEmployeeNote, { employeeId: action.employeeId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_EMPLOYEE_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateEmployeeNote() {
  yield takeLatest(constants.CREATE_EMPLOYEE_NOTE.ACTION, createEmployeeNote)
}

function* editEmployeeNote(action) {
  try {
    const payload = {
      content: action.content,
      noteId: action.noteId
    }
    yield call(api.editEmployeeNote, payload)
    yield put({ type: constants.EDIT_EMPLOYEE_NOTE.SUCCESS, payload })
    yield call(fetchEmployeeNote, { employeeId: action.employeeId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_EMPLOYEE_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditEmployeeNote() {
  yield takeLatest(constants.EDIT_EMPLOYEE_NOTE.ACTION, editEmployeeNote)
}

function* deleteEmployeeNote(action) {
  try {
    const payload = {
      noteId: action.noteId
    }
    yield call(api.deleteEmployeeNote, payload)
    yield put({ type: constants.DELETE_EMPLOYEE_NOTE.SUCCESS, payload })
    yield call(fetchEmployeeNote, { employeeId: action.employeeId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_EMPLOYEE_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteEmployeeNote() {
  yield takeLatest(constants.DELETE_EMPLOYEE_NOTE.ACTION, deleteEmployeeNote)
}

// followUps
function* fetchEmployeeFollowUp(action) {
  try {
    const payload = yield call(api.fetchEmployeeFollowUp, { employeeId: action.employeeId })
    yield put({ type: constants.GET_EMPLOYEE_FOLLOW_UP.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_EMPLOYEE_FOLLOW_UP.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchEmployeeFollowUp() {
  yield takeLatest(constants.GET_EMPLOYEE_FOLLOW_UP.ACTION, fetchEmployeeFollowUp)
}

function* createEmployeeFollowUp(action) {
  try {
    const payload = {
      content: action.content,
      employeeId: action.employeeId
    }
    yield call(api.createEmployeeFollowUp, payload)
    yield put({ type: constants.CREATE_EMPLOYEE_FOLLOW_UP.SUCCESS, payload })
    yield call(fetchEmployeeFollowUp, { employeeId: action.employeeId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_EMPLOYEE_FOLLOW_UP.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateEmployeeFollowUp() {
  yield takeLatest(constants.CREATE_EMPLOYEE_FOLLOW_UP.ACTION, createEmployeeFollowUp)
}

function* editEmployeeFollowUp(action) {
  try {
    const payload = {
      content: action.content,
      followUpId: action.followUpId
    }
    yield call(api.editEmployeeFollowUp, payload)
    yield put({ type: constants.EDIT_EMPLOYEE_FOLLOW_UP.SUCCESS, payload })
    yield call(fetchEmployeeFollowUp, { employeeId: action.employeeId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_EMPLOYEE_FOLLOW_UP.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditEmployeeFollowUp() {
  yield takeLatest(constants.EDIT_EMPLOYEE_FOLLOW_UP.ACTION, editEmployeeFollowUp)
}

function* deleteEmployeeFollowUp(action) {
  try {
    const payload = {
      followUpId: action.followUpId
    }
    yield call(api.deleteEmployeeFollowUp, payload)
    yield put({ type: constants.DELETE_EMPLOYEE_FOLLOW_UP.SUCCESS, payload })
    yield call(fetchEmployeeFollowUp, { employeeId: action.employeeId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_EMPLOYEE_FOLLOW_UP.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteEmployeeFollowUp() {
  yield takeLatest(constants.DELETE_EMPLOYEE_FOLLOW_UP.ACTION, deleteEmployeeFollowUp)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(employeesRefresh),
    fork(watchCreateEmployee),
    fork(watchEditEmployee),
    fork(watchDeleteEmployee),
    fork(watchEditEmployeeStatus),

    fork(watchUploadAttachments),
    fork(watchGetAttachments),
    fork(watchUpdateAttachmentDescription),
    fork(watchDeleteAttachments),

    fork(watchFetchEmployeeNote),
    fork(watchCreateEmployeeNote),
    fork(watchEditEmployeeNote),
    fork(watchDeleteEmployeeNote),

    fork(watchFetchEmployeeFollowUp),
    fork(watchCreateEmployeeFollowUp),
    fork(watchEditEmployeeFollowUp),
    fork(watchDeleteEmployeeFollowUp)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/employeesSaga.js